<ion-header class="bevme-header" [translucent]="false">
  <ion-toolbar>

    <ion-buttons slot="start" *ngIf="showBack">
      <ion-back-button
        [defaultHref]="backRoute || '/tabs/explore'"
        [icon]="backIconName"
        [text]="''"
        [attr.aria-label]="backAriaLabel">
      </ion-back-button>
    </ion-buttons>

    <ion-buttons slot="start" *ngIf="canShowPeopleSearch()">
      <ion-button
        fill="clear"
        class="people-search-btn"
        (click)="openPeopleSearch()"
        aria-label="Find people">
        <ion-icon name="people-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title class="bevme-title">
      <img [src]="logoSrc" class="bevme-logo" alt="BevMe" />
    </ion-title>

    <ion-buttons slot="end" *ngIf="canShowNotifications()">
      <ion-button
        fill="clear"
        class="notification-btn"
        (click)="openNotifications()"
        aria-label="Notifications">
        <span class="notification-icon-wrap">
          <ion-icon name="notifications-outline"></ion-icon>
          <ion-badge *ngIf="(unreadCount$ | async) as unreadCount" [hidden]="unreadCount <= 0">
            {{ unreadCount > 99 ? '99+' : unreadCount }}
          </ion-badge>
        </span>
      </ion-button>
    </ion-buttons>

  </ion-toolbar>
</ion-header>
